import React from 'react';

export default (props) => (

    <div className="edit-email-address">
        <div
            className={!props.validationErrors.email.status ? "text-field" : "text-field has-error"}
        >
            <label className="text-field__label" htmlFor="">Email</label>
            <input
                className="text-field__input"
                type="text"
                value={props.user.email}
                onChange={(e) => props.handleChange('email', e.target.value)}
                placeholder="Email Address"
            />
            <span className="error-message">{props.validationErrors.email.message}</span>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/components/Profile/editEmail.js